/* ===========================================================================
   Pack Personnalisable — contrôleur du configurateur.

   - Aucun framework, aucune dépendance : lit sa config depuis un <script
     type="application/json"> injecté par la section Liquid.
   - Ajout panier : construit un tableau `items` (1 ligne par recharge + 1 pour
     le flacon) => chaque produit reste une LIGNE SÉPARÉE dans le checkout.
   - Réutilise l'infra panier existante du thème (mmAPIRequest /
     refreshCartFromData / mmOpenCart) sans la modifier. Fallback /cart si absente.
   - Prix = SOMME des variantes sélectionnées (aucune remise appliquée côté thème).
   ========================================================================== */
(function () {
  'use strict';

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function uid() {
    return 'pp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
  }

  var MAX = 3;

  function PackConfigurator(root) {
    this.root = root;
    var cfgEl = document.getElementById(root.dataset.configId);
    if (!cfgEl) return;
    this.cfg = JSON.parse(cfgEl.textContent);

    // état
    this.qty = {};
    this.cfg.scents.forEach(function (s) { this.qty[s.id] = 0; }, this);
    this.format = (this.cfg.formulas[0] && this.cfg.formulas[0].id) || 'pack';
    this.added = false;

    this.cap = this.cfg.allowDuplicates ? MAX : 1;

    this.cacheDom();
    this.bind();
    this.render();
  }

  PackConfigurator.prototype.cacheDom = function () {
    var r = this.root;
    this.$counter = r.querySelector('[data-pp-counter]');
    this.$hint = r.querySelector('[data-pp-duphint]');
    this.$slots = r.querySelectorAll('[data-pp-slot]');
    this.$formats = r.querySelectorAll('[data-pp-format]');
    this.$priceNow = r.querySelector('[data-pp-price-now]');
    this.$priceOld = r.querySelector('[data-pp-price-old]');
    this.$priceHint = r.querySelector('[data-pp-price-hint]');
    this.$cta = r.querySelector('[data-pp-cta]');
    this.$scentRows = r.querySelectorAll('[data-pp-scent]');
    this.$thumbs = r.querySelectorAll('[data-pp-thumb]');
    this.$mainImg = r.querySelector('[data-pp-main-img]');
  };

  PackConfigurator.prototype.bind = function () {
    var self = this;

    this.$scentRows.forEach(function (row) {
      var id = row.dataset.ppScent;
      var inc = row.querySelector('[data-pp-inc]');
      var dec = row.querySelector('[data-pp-dec]');
      if (inc) inc.addEventListener('click', function () { self.setQty(id, 1); });
      if (dec) dec.addEventListener('click', function () { self.setQty(id, -1); });
    });

    this.$formats.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.format = btn.dataset.ppFormat;
        self.added = false;
        self.render();
      });
    });

    this.$thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.ppThumb;
        if (src && self.$mainImg) self.$mainImg.src = src;
        self.$thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    if (this.$cta) this.$cta.addEventListener('click', function () { self.addToCart(); });
  };

  PackConfigurator.prototype.total = function () {
    var t = 0, q = this.qty;
    Object.keys(q).forEach(function (k) { t += q[k]; });
    return t;
  };

  PackConfigurator.prototype.scentById = function (id) {
    return this.cfg.scents.filter(function (s) { return s.id === id; })[0];
  };

  PackConfigurator.prototype.setQty = function (id, d) {
    var total = this.total();
    var s = this.scentById(id);
    if (!s || !s.available) return;
    if (d > 0 && total >= MAX) return;
    var next = Math.max(0, Math.min(this.qty[id] + d, this.cap));
    this.qty[id] = next;
    this.added = false;
    this.render();
  };

  // Prix = somme des variantes. Renvoie un montant en centimes.
  PackConfigurator.prototype.selectionCents = function (includeFlacon) {
    var cents = 0, self = this;
    this.cfg.scents.forEach(function (s) { cents += self.qty[s.id] * s.price; });
    if (includeFlacon && this.cfg.flacon) cents += this.cfg.flacon.price;
    return cents;
  };
  // Prix indicatif d'une formule avant sélection complète (3 recharges au prix de référence).
  PackConfigurator.prototype.formulaEstimateCents = function (formulaId) {
    var ref = this.cfg.refPrice || 0;
    var cents = ref * MAX;
    if (formulaId === 'pack' && this.cfg.flacon) cents += this.cfg.flacon.price;
    return cents;
  };

  PackConfigurator.prototype.isPack = function () { return this.format === 'pack'; };

  PackConfigurator.prototype.render = function () {
    var self = this;
    var total = this.total();
    var remaining = MAX - total;

    // Cartes parfums
    this.$scentRows.forEach(function (row) {
      var id = row.dataset.ppScent;
      var s = self.scentById(id);
      var q = self.qty[id];
      var canInc = s && s.available && total < MAX && q < self.cap;
      row.classList.toggle('is-picked', q > 0);
      row.classList.toggle('is-disabled', !!s && !s.available);
      var qEl = row.querySelector('[data-pp-qty]');
      if (qEl) qEl.textContent = q;
      var inc = row.querySelector('[data-pp-inc]');
      var dec = row.querySelector('[data-pp-dec]');
      if (inc) inc.disabled = !canInc;
      if (dec) dec.disabled = q <= 0;
    });

    // Compteur
    if (this.$counter) {
      this.$counter.textContent = total + '/' + MAX;
      this.$counter.classList.toggle('is-complete', remaining === 0);
    }

    // Slots "Ma sélection"
    var picked = [];
    this.cfg.scents.forEach(function (s) {
      for (var i = 0; i < self.qty[s.id]; i++) picked.push(s.short || s.name.split(' ')[0]);
    });
    this.$slots.forEach(function (slot, i) {
      slot.textContent = picked[i] || '?';
      slot.classList.toggle('is-filled', !!picked[i]);
    });

    // Formules : prix + état actif
    this.$formats.forEach(function (btn) {
      var fid = btn.dataset.ppFormat;
      var active = fid === self.format;
      btn.classList.toggle('is-active', active);
      var priceEl = btn.querySelector('[data-pp-format-price]');
      if (priceEl) {
        var t = (fid === 'pack') ? self.cfg.packTarget : self.cfg.refillTarget;
        var cents = (t != null && t !== '')
          ? t
          : ((total === MAX) ? self.selectionCents(fid === 'pack') : self.formulaEstimateCents(fid));
        priceEl.textContent = euro(cents);
      }
    });

    // Prix sticky : prix pack cible (remise auto Shopify) + somme plein tarif barrée.
    // Sans prix cible configuré => on affiche simplement la somme des variantes (option A).
    var fullCents = this.selectionCents(this.isPack());
    var target = this.isPack() ? this.cfg.packTarget : this.cfg.refillTarget;
    var nowCents = (target != null && target !== '') ? target : fullCents;

    if (this.$priceNow) this.$priceNow.textContent = euro(nowCents);
    if (this.$priceOld) {
      this.$priceOld.textContent = (fullCents > nowCents) ? euro(fullCents) : '';
    }
    if (this.$priceHint) {
      this.$priceHint.textContent = (total === MAX) ? 'soit ' + euro(Math.round(nowCents / MAX)) + ' le déo' : '';
    }

    // CTA
    if (this.$cta) {
      var label;
      if (this.added) {
        label = 'Ajouté au panier ✓';
      } else if (remaining === MAX) {
        label = this.cfg.labels.ctaEmpty || 'Choisissez vos 3 parfums';
      } else if (remaining > 0) {
        label = 'Encore ' + remaining + ' parfum' + (remaining > 1 ? 's' : '') + ' à choisir';
      } else {
        label = (this.cfg.labels.ctaReady || "J'ajoute au panier") + ' · ' + euro(nowCents);
      }
      this.$cta.textContent = label;
      this.$cta.disabled = remaining > 0;
      this.$cta.classList.toggle('is-added', this.added);
    }
  };

  PackConfigurator.prototype.buildItems = function () {
    var self = this;
    var packId = uid();
    var packLabel = this.cfg.packLabel || 'Pack Personnalisable';
    var items = [];

    this.cfg.scents.forEach(function (s) {
      if (self.qty[s.id] > 0) {
        items.push({
          id: s.variantId,
          quantity: self.qty[s.id],
          properties: { '_pack': packLabel, '_pack_id': packId, '_Parfum': s.name },
        });
      }
    });

    if (this.isPack() && this.cfg.flacon) {
      items.push({
        id: this.cfg.flacon.variantId,
        quantity: 1,
        properties: { '_pack': packLabel, '_pack_id': packId },
      });
    }

    return items;
  };

  PackConfigurator.prototype.addToCart = function () {
    if (this.total() < MAX || this.added) return;
    var self = this;
    var items = this.buildItems();
    if (!items.length) return;

    this.root.classList.add('is-loading');

    // Chemin privilégié : infra panier du thème (drawer mm-cart).
    if (typeof window.mmAPIRequest === 'function') {
      window.mmAPIRequest('POST', 'cart/add.js', { items: items, sections: 'mm-cart' })
        .then(function (data) {
          if (typeof window.refreshCartFromData === 'function') {
            try { window.refreshCartFromData(data); } catch (e) {}
          }
          self.onAdded();
          if (typeof window.mmOpenCart === 'function') setTimeout(window.mmOpenCart);
        })
        .catch(function (err) { self.onError(err); });
      return;
    }

    // Fallback : AJAX standard puis redirection panier.
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) { if (!res.ok) throw res; return res.json(); })
      .then(function () { self.onAdded(); window.location.href = '/cart'; })
      .catch(function (err) { self.onError(err); });
  };

  PackConfigurator.prototype.onAdded = function () {
    this.root.classList.remove('is-loading');
    this.added = true;
    this.render();
    var self = this;
    clearTimeout(this._t);
    this._t = setTimeout(function () { self.added = false; self.render(); }, 2500);
  };

  PackConfigurator.prototype.onError = function (err) {
    this.root.classList.remove('is-loading');
    console.error('[pack-personnalisable] add to cart failed', err);
    if (this.$cta) this.$cta.textContent = 'Oups, réessayez';
  };

  function init() {
    document.querySelectorAll('[data-pp-root]').forEach(function (root) {
      if (root.__ppInit) return;
      root.__ppInit = true;
      try { new PackConfigurator(root); } catch (e) { console.error('[pack-personnalisable]', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Support éditeur de thème Shopify (rechargement de section)
  document.addEventListener('shopify:section:load', init);
})();
